<template>
  <div id="login">
    <div class="loginCont">
      <img src="../assets/leftPic.png" alt="" class="left">
      <div class="right">
        <p class="title">账号登录</p>
        <a-form :form="form" @submit="goLogin" :hideRequiredMark="true" layout="horizontal">
          <a-form-item label="用户名：">
            <a-input placeholder="请输入用户名" 
              v-decorator="['uname',{ rules: [{ required: true, message: '请输入正确的用户名',whitespace:true }] }]" 
            />
          </a-form-item>
          <a-form-item label="密码：" labelAlign="right">
            <a-input-password placeholder="请输入密码"
              v-decorator="['pwd',{ rules: [{ required: true, message: '请输入正确的密码' }] }]" 
             />
          </a-form-item>
          <a-form-item class="alignRight">
            <a-checkbox :checked="isCheckPwd" @change="checkPwd" v-decorator="['check',{initialValue:true},{ rules: [{ required: false}] },]" >记住密码</a-checkbox>
          </a-form-item>
          <a-form-item class="alighBetween">
            <a-button type="default" @click="goRegister">注册</a-button>
            <a-button type="primary" html-type="submit">登录</a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>

import '../sass/login.min.css'

export default {
  name:'login',
  data(){
    return{
      isCheckPwd:true,
      form:this.$form.createForm(this,{name:'login'}),
    }
  },
  methods:{
    checkPwd(e){
      this.isCheckPwd = e.target.checked;
      console.log('是否记住密码',e);
    },
    goRegister(){
      //去注册
    },
    goLogin(e){
      e.preventDefault();
      //去登录
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
          if(this.isCheckPwd){
            this.$cookies.set('uname',values.uname);
            this.$cookies.set('pwd',values.pwd);
          }else{
            this.$cookies.remove('uname');
            this.$cookies.remove('pwd');
          }
          //调用接口
          const src = 'login/soshow';
          const data = {
              nickname:values.uname,
              password:values.pwd,
          };
          const loginFun = (res) => {
            console.log(res);
            this.$message.success('登录成功');
            this.$router.push({name: "index",query: {}});
          };
          this.$commonApi.$axios(src,data,loginFun);
        }
      });
    }
  },
  created(){
    this.$myStore.setMessageAction(1);
  },
  mounted(){
    if(this.$cookies.get('uname')){
      this.form.setFieldsValue({ uname: this.$cookies.get('uname') });
    }
    if(this.$cookies.get('pwd')){
      this.form.setFieldsValue({ pwd: this.$cookies.get('pwd') });
    }
  }
}
</script>